import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { FunctionComponent, PropsWithChildren, useContext, useEffect, useState } from 'react';
import { UserDetailsContext } from '../context/user-details/user-details';

const SuperAdmin: FunctionComponent<{ children?: PropsWithChildren }> = ({ children }) => {
  const location = useLocation();
  const userDetailsContext = useContext(UserDetailsContext);

  const [isLoading, setIsLoading] = useState(true);
  const [canAccess, setCanAccess] = useState(false);

  useEffect(() => {

    setIsLoading(true)
    setCanAccess(false)

    async function checkAuth() {
      setIsLoading(true);
      setCanAccess(false);

      let userDetails = userDetailsContext.userDetails;

      if (!userDetails) {
        userDetails = await userDetailsContext.forceUpdateUserDetails();
      }

      if (userDetails) {
        if (userDetails.isSuperAdmin) {
          setCanAccess(true);
          setIsLoading(false);
        }
        else {
          setIsLoading(false)
        }
      }
      else {
        setIsLoading(false)
      }
    }

    checkAuth()

  }, [window.location.pathname])

  return isLoading ? null : canAccess ? <Outlet /> : <Navigate to="/dashboard" state={{ from: location }} replace />;
}

export default SuperAdmin;
